module.exports = __webpack_public_path__ + "img/extended.71451cfb.png";